import React, { Fragment, useEffect, useState } from 'react';
import './../Resources/css/block_catering.css'
import Common from '../../../Shared/Common';
import Block from '../../../Controls/Scafolding/Block';

import { Container, Row, Col } from 'reactstrap';
import { TextBock, TextHeader, TextTitle } from '../../../Controls/Digital/TextHeaders';

import img_1 from '../Resources/Images/Catering/B&E.jpg';                                    
import img_2 from '../Resources/Images/Catering/Baked cheesecake.jpg';
import img_3 from '../Resources/Images/Catering/Brownies.jpg';                       
import img_4 from '../Resources/Images/Catering/Chicken wrap.jpg';                           
import img_5 from '../Resources/Images/Catering/Cinnamon Scrolls.jpg';                       
import img_6 from '../Resources/Images/Catering/Custard tart.jpg';                           
import img_7 from '../Resources/Images/Catering/Nutella macaroons.jpg';
import img_8 from '../Resources/Images/Catering/Pistachiodelish.jpg';                        
import img_9 from '../Resources/Images/Catering/Signoras Bakery hero 222.jpg';              
import img_10 from '../Resources/Images/Catering/Signoras Bakery hero.jpg';              
import img_11 from '../Resources/Images/Catering/Snithzel panini.jpg';                        
import img_12 from '../Resources/Images/Catering/Vanilla Slice.jpg';                          
import img_13 from '../Resources/Images/Catering/Veg Wrap.jpg';
import img_14 from '../Resources/Images/Catering/Yogurt.jpg';                              

import { AnimatedImage } from '../../../Controls/Digital/AnimatedImage';
import { ContactUsButton } from '../Components/ContactUsButton';

const Catering = (props) =>{

    const [blockName, setBlockName] = useState("");

    useEffect(() => {
        setBlockName(props.name);
        Common.traceInit("Block " + blockName);
    });

    return (
        <Block name="catering" isAlt={true}>

            <TextHeader text={
                <Fragment>
                    Catering & Events
                </Fragment>
            } />

            {/*<Row>*/}
            {/*    <Col>*/}
            {/*        <br />*/}
            {/*        Option 1*/}
            {/*        <br />*/}
            {/*    </Col>*/}
            {/*</Row>*/}

            <TextTitle text={
                <Fragment>
                    Let us take care of your events
                </Fragment>
            } />

            <TextBock addClass="text-center" text={
                <Fragment>
                    <ContactUsButton />
                </Fragment>
            } />

            <TextBock lg={{ size: 8, offset: 2 }} text={
                <Fragment>
                    From casual to corporate lunch, birthday parties and Weddings we can design a custom catering solution for your specific needs.
                </Fragment>
            } />


            <Row>
                <Col><AnimatedImage image={img_1} /></Col>
                <Col><AnimatedImage image={img_2 } /></Col>
                <Col><AnimatedImage image={img_4} /></Col>
                <Col><AnimatedImage image={img_5 } /></Col>
                <Col><AnimatedImage image={img_6 } /></Col>
            </Row>

            <Row>
                <Col><AnimatedImage image={img_7} /></Col>
                <Col><AnimatedImage image={img_8} /></Col>
                <Col><AnimatedImage image={img_9} /></Col>
                <Col><AnimatedImage image={img_10} /></Col>
                <Col><AnimatedImage image={img_11} /></Col>
            </Row>

            <Row>
                <Col><AnimatedImage image={img_12} /></Col>
                <Col><AnimatedImage image={img_13} /></Col>
                <Col><AnimatedImage image={img_14} /></Col>
            </Row>

            <TextBock lg={{ size: 8, offset: 2 }} text={
                <Fragment>
                    Together with our sister business <span className="catering-highlight">Signora's Cafe</span>  we serve quality rustic authentic food for our amazing Illawara community.
                </Fragment>
            } />


            {/*<Row>*/}
            {/*    <Col>*/}
            {/*        <br />*/}
            {/*        Option 2*/}
            {/*        <br />*/}
            {/*    </Col>*/}
            {/*</Row>*/}


            {/*<TextTitle text={*/}
            {/*    <Fragment>*/}
            {/*        Let us take care of your events*/}
            {/*    </Fragment>*/}
            {/*} />*/}

            {/*<TextBock addClass="text-center" text={*/}
            {/*    <Fragment>*/}
            {/*        <ContactUsButton />*/}
            {/*    </Fragment>*/}
            {/*} />*/}

            {/*<Row>*/}
            {/*    <Col><AnimatedImage image={img_1} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_2} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_4} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_5} /></Col>*/}
            {/*</Row>*/}

            {/*<Row>*/}
            {/*    <Col><AnimatedImage image={img_6} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_7} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_8} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_9} /></Col>*/}
            {/*</Row>*/}

            {/*<Row>*/}
            {/*    <Col><AnimatedImage image={img_10} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_11} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_12} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_13} /></Col>*/}
            {/*</Row>*/}
            {/*<Row>*/}
            {/*    <Col><AnimatedImage image={img_14} /></Col>*/}
            {/*    <Col>*/}
            {/*        <Container>*/}

            {/*            <TextBock lg={{ size: 8, offset: 2 }} text={*/}
            {/*                <Fragment>*/}
            {/*                    From casual to corporate lunch, birthday parties and Weddings we can design a custom catering solution for your specific needs.*/}
            {/*                </Fragment>*/}
            {/*            } />*/}

            {/*            <TextBock lg={{ size: 8, offset: 2 }} text={*/}
            {/*                <Fragment>*/}
            {/*                    Together with our sister business <span className="catering-highlight">Signora's Cafe</span>  we serve quality rustic authentic food for our amazing Illawara community.*/}
            {/*                </Fragment>*/}
            {/*            } />*/}

            {/*        </Container>*/}
                   
            {/*    </Col>*/}
            {/*</Row>*/}


            {/*<Row>*/}
            {/*    <Col>*/}
            {/*        <br />*/}
            {/*        Option 3*/}
            {/*        <br />*/}
            {/*    </Col>*/}
            {/*</Row>*/}

            {/*<Row>*/}
            {/*    <Col><AnimatedImage image={img_13} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_2} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_14} /></Col>*/}
            {/*</Row>*/}

            {/*<Row>*/}
            {/*    <Col><AnimatedImage image={img_4} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_5} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_6} /></Col>*/}
            {/*</Row>*/}

            {/*<Row>*/}
            {/*    <Col><AnimatedImage image={img_7} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_8} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_9} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_10} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_11} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_12} /></Col>*/}
            {/*</Row>*/}

            {/*<Row>*/}
            {/*    <Col><AnimatedImage image={img_1} /></Col>*/}
            {/*    <Col>*/}

            {/*        <TextTitle text={*/}
            {/*            <Fragment>*/}
            {/*                Let us take care of your events*/}
            {/*            </Fragment>*/}
            {/*        } />*/}

            {/*        <TextBock lg={{ size: 8, offset: 2 }} text={*/}
            {/*            <Fragment>*/}
            {/*                From casual to corporate lunch, birthday parties and Weddings we can design a custom catering solution for your specific needs.*/}
            {/*            </Fragment>*/}
            {/*        } />*/}

            {/*        <TextBock addClass="left-text" text={*/}
            {/*            <Fragment>*/}
            {/*                Together with our sister business <span className="catering-highlight">Signora's Cafe</span>  we serve quality rustic authentic food for our amazing Illawara community.*/}
            {/*            </Fragment>*/}
            {/*        } />*/}


            {/*        <TextBock addClass="text-center" text={*/}
            {/*            <Fragment>*/}
            {/*                <ContactUsButton />*/}
            {/*            </Fragment>*/}
            {/*        } />*/}

            {/*    </Col>*/}
            {/*</Row>*/}

            {/*<Row>*/}
            {/*    <Col>*/}
            {/*        <br />*/}
            {/*        Option 4*/}
            {/*        <br />*/}
            {/*    </Col>*/}
            {/*</Row>*/}

            {/*<TextTitle text={*/}
            {/*    <Fragment>*/}
            {/*        Let us take care of your events*/}
            {/*    </Fragment>*/}
            {/*} />*/}


            {/*<Row>*/}
            {/*    <Col><AnimatedImage image={img_1} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_2} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_3} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_4} /></Col>*/}
            {/*</Row>*/}
            {/*<Row>*/}
            {/*    <Col><AnimatedImage image={img_5} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_6} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_7} /></Col>*/}
            {/*</Row>*/}
            {/*<Row>*/}
            {/*    <Col><AnimatedImage image={img_8} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_9} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_10} /></Col>*/}
            {/*</Row>*/}
            {/*<Row>*/}
            {/*    <Col><AnimatedImage image={img_11} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_12} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_13} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_14} /></Col>*/}
            {/*</Row>*/}


            {/*<TextBock lg={{ size: 8, offset: 2 }} text={*/}
            {/*    <Fragment>*/}
            {/*        Together with our sister business <span className="catering-highlight">Signora's Cafe</span>  we serve quality rustic authentic food for our amazing Illawara community.*/}
            {/*    </Fragment>*/}
            {/*} />*/}

            {/*<TextBock lg={{ size: 8, offset: 2 }} text={*/}
            {/*    <Fragment>*/}
            {/*        From casual to corporate lunch, birthday parties and Weddings we can design a custom catering solution for your specific needs.*/}
            {/*    </Fragment>*/}
            {/*} />*/}

            {/*<TextBock addClass="text-center" text={*/}
            {/*    <Fragment>*/}
            {/*        <ContactUsButton />*/}
            {/*    </Fragment>*/}
            {/*} />*/}

            {/*<Row>*/}
            {/*    <Col>*/}
            {/*        <br />*/}
            {/*        Option 5*/}
            {/*        <br />*/}
            {/*    </Col>*/}
            {/*</Row>*/}


            {/*<Row>*/}
            {/*    <Col lg="4"><AnimatedImage image={img_1} /></Col>*/}
            {/*    <Col lg="4"><AnimatedImage image={img_2} /></Col>*/}
            {/*    <Col lg="4"><AnimatedImage image={img_3} /></Col>*/}
            {/*</Row>*/}
            {/*<Row>*/}
            {/*    <Col lg="6"><AnimatedImage image={img_4} /></Col>*/}
            {/*    <Col lg="6">*/}
            {/*        <Container>*/}
            {/*            <Row>*/}
            {/*                <Col lg="6"><AnimatedImage image={img_5} /></Col>*/}
            {/*                <Col lg="6"><AnimatedImage image={img_6} /></Col>*/}
            {/*            </Row>*/}
            {/*            <Row>*/}
            {/*                <Col lg="6"><AnimatedImage image={img_7} /></Col>*/}
            {/*                <Col lg="6"><AnimatedImage image={img_8} /></Col>*/}
            {/*            </Row>*/}
            {/*        </Container>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
            {/*<Row>*/}
            {/*    <Col><AnimatedImage image={img_8} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_9} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_10} /></Col>*/}
            {/*</Row>*/}
            {/*<Row>*/}
            {/*    <Col><AnimatedImage image={img_11} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_12} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_13} /></Col>*/}
            {/*</Row>*/}


            {/*<Row>*/}
            {/*    <Col><AnimatedImage image={img_14} /></Col>*/}
            {/*    <Col>*/}

            {/*        <TextTitle text={*/}
            {/*            <Fragment>*/}
            {/*                Let us take care of your events*/}
            {/*            </Fragment>*/}
            {/*        } />*/}

            {/*        <TextBock lg={{ size: 8, offset: 2 }} text={*/}
            {/*            <Fragment>*/}
            {/*                From casual to corporate lunch, birthday parties and Weddings we can design a custom catering solution for your specific needs.*/}
            {/*            </Fragment>*/}
            {/*        } />*/}

            {/*        <TextBock addClass="left-text" text={*/}
            {/*            <Fragment>*/}
            {/*                Together with our sister business <span className="catering-highlight">Signora's Cafe</span>  we serve quality rustic authentic food for our amazing Illawara community.*/}
            {/*            </Fragment>*/}
            {/*        } />*/}


            {/*        <TextBock addClass="text-center" text={*/}
            {/*            <Fragment>*/}
            {/*                <ContactUsButton />*/}
            {/*            </Fragment>*/}
            {/*        } />*/}

            {/*    </Col>*/}
            {/*</Row>*/}

            {/*<Row>*/}
            {/*    <Col>*/}
            {/*        <br /> */}
            {/*        Option 6*/}
            {/*        <br />*/}
            {/*    </Col>*/}
            {/*</Row>*/}

            {/*<Row>*/}
            {/*    <Col lg="4"><AnimatedImage image={img_1} /></Col>*/}
            {/*    <Col lg="4"><AnimatedImage image={img_2} /></Col>*/}
            {/*    <Col lg="4"><AnimatedImage image={img_3} /></Col>*/}
            {/*</Row>*/}
            {/*<Row>*/}
            {/*    <Col lg="6"><AnimatedImage image={img_4} /></Col>*/}
            {/*    <Col lg="6">*/}
            {/*        <Container>*/}
            {/*            <Row>*/}
            {/*                <Col lg="6"><AnimatedImage image={img_5} /></Col>*/}
            {/*                <Col lg="6"><AnimatedImage image={img_6} /></Col>*/}
            {/*            </Row>*/}
            {/*            <Row>*/}
            {/*                <Col lg="6"><AnimatedImage image={img_7} /></Col>*/}
            {/*                <Col lg="6"><AnimatedImage image={img_8} /></Col>*/}
            {/*            </Row>*/}
            {/*        </Container>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
            {/*<Row>*/}
            {/*    <Col><AnimatedImage image={img_8} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_9} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_10} /></Col>*/}
            {/*    <Col><AnimatedImage image={img_11} /></Col>*/}
            {/*</Row>*/}

            {/*<Row>*/}
            {/*    <Col lg="6">*/}
            {/*        <Container>*/}
            {/*            <Row>*/}
            {/*                <Col><AnimatedImage image={img_12} /></Col>*/}
            {/*            </Row>*/}

            {/*            <Row>*/}
            {/*                <Col><AnimatedImage image={img_13} /></Col>*/}
            {/*            </Row>*/}
            {/*        </Container>*/}
            {/*    </Col>*/}

            {/*    <Col lg="6">*/}
            {/*        <Container>*/}
            {/*            <Row>*/}
            {/*                <Col><AnimatedImage image={img_14} /></Col>*/}
            {/*            </Row>*/}


            {/*            <TextTitle text={*/}
            {/*                <Fragment>*/}
            {/*                    Let us take care of your events*/}
            {/*                </Fragment>*/}
            {/*            } />*/}

            {/*            <TextBock lg={{ size: 8, offset: 2 }} text={*/}
            {/*                <Fragment>*/}
            {/*                    From casual to corporate lunch, birthday parties and Weddings we can design a custom catering solution for your specific needs.*/}
            {/*                </Fragment>*/}
            {/*            } />*/}

            {/*            <TextBock addClass="left-text" text={*/}
            {/*                <Fragment>*/}
            {/*                    Together with our sister business <span className="catering-highlight">Signora's Cafe</span>  we serve quality rustic authentic food for our amazing Illawara community.*/}
            {/*                </Fragment>*/}
            {/*            } />*/}


            {/*            <TextBock addClass="text-center" text={*/}
            {/*                <Fragment>*/}
            {/*                    <ContactUsButton />*/}
            {/*                </Fragment>*/}
            {/*            } />*/}

            {/*        </Container>*/}
            {/*    </Col>*/}
            {/*</Row>*/}

            <Row>
                <Col>
                    <br />
                </Col>
            </Row>

            <TextTitle text={
                <Fragment>
                    <br />
                    Catering price list
                </Fragment>
            } />

            <Row>
                <Col lg={{ size:6, offset: 4 }}>

                    <p className="catering-header">
                        Starting Pack Catering - <span className="catering-price">$15,50 per person</span>
                    </p>
                    <p className="catering-body">
                        Mix sandwiches, a taste of sweets and a small fruit platter
                    </p>

                    <p className="catering-header">
                        Feed us! - <span className="catering-price">$20,00 per person</span>
                    </p>
                    <p className="catering-body">
                        Mix Sandwiches, mix slice and sweets platter, large fruit platter
                    </p>

                    <p className="catering-header">
                        Deluxe - <span className="catering-price">$25,00 per person</span>
                    </p>

                    <p className="catering-body">
                        Mix Sandwiches and wraps, slices and sweets deluxe platter, tropical fruit platter
                    </p>
                </Col>
            </Row>

            <Row>
                <Col lg={{ size: 5, offset: 2 }}>
                    <p className="catering-header">
                        Add Ons
                    </p>
                    <ul>
                        <li>Lasagna tray (8-10 portions) <span className="catering-price">$59</span>                                   </li>
                        <li>Moussaka tray (8-10 portions) <span className="catering-price">$59</span>                                  </li>
                        <li>Spinach Ricotta Cannelloni tray (8-10 portions) <span className="catering-price">$59</span>                </li>
                        <li>Fried Rice tray (8-10 portions) <span className="catering-price">$39</span>                                </li>
                        <li>Creamy garlic bacon pasta (8-10 portions) <span className="catering-price">$39</span>                      </li>
                        <li>Pesto chicken pasta (8-10 portions) <span className="catering-price">$39</span>                            </li>
                        <li>Bolognese pasta (8-10 portions) <span className="catering-price">$39</span>                                </li>
                        <li>Grazing platter <span className="catering-price">$30 per Kg</span>                                         </li>
                        <li>Garden salad tray (8-10 portions) <span className="catering-price">$19</span>                              </li>
                        <li>Greek salad (8-10 portions) <span className="catering-price">$25</span>                                    </li>
                        <li>Coleslaw (8-10 portions) <span className="catering-price">$19</span>                                       </li>
                        <li>Potato and bacon Salad (8-10 portions) <span className="catering-price">$25</span>                         </li>
                        <li>Family quiche (Lorraine, spinach feta, grilled vegetable) <span className="catering-price">$35</span>      </li>
                        <li>Spinach cheese Spanakopita tray (4-6 portions) <span className="catering-price">$30</span>                 </li>
                        <li>Muffins (choc chip, blueberry) <span className="catering-price">$60 (13)</span>                            </li>
                        <li>Tiramisu tray (10-15 portions) <span className="catering-price">$49</span>                                 </li>
                        <li>Mix cannoli tray (Chocolate, custard, ricotta, pistachio) 12 <span className="catering-price">$65</span>   </li>
                        <li>Assorted Bread rolls <span className="catering-price">$1.1 each</span>                                     </li>
                    </ul>
                </Col>

                <Col lg="5">
                    <p className="catering-header">
                        Canapes
                    </p>
                    <ul>
                        <li>Mini quiches <span className="catering-price">3.5 each</span>               </li>
                        <li>Mini mince pies <span className="catering-price">$3.5 each</span>            </li>
                        <li>Mini Sausage rolls <span className="catering-price">$2 each</span>           </li>
                        <li>Mini Spinach rolls <span className="catering-price">$2.5 each</span>         </li>
                        <li>Arancini <span className="catering-price">$3.5 each</span>                   </li>
                    </ul>

                    {/*<p className="catering-header">*/}
                    {/*    Cakes*/}
                    {/*</p>*/}
                    {/*<ul>*/}
                    {/*    <li>Sponge 7 inch <span className="catering-price">$39</span>, 10 inch <span className="catering-price">$59</span>                                                                     </li>*/}
                    {/*    <li>Mud cake, Red velvet 7 inch <span className="catering-price">$49</span>, 10 inch, <span className="catering-price">$69</span>                                                      </li>*/}
                    {/*    <li>Cheesecake 10 inch <span className="catering-price">$79</span> (Biscoff, Nutella, Pistachio, Berry compote)                                </li>*/}
                    {/*    <li>Cannoli tower 10 cannoli <span className="catering-price">$60</span>, 20 cannoli <span className="catering-price">$110</span> (Ricotta, Pistachio, Chocolate, raspberry, Custard)  </li>*/}
                    {/*    <li>Hummingbird cake 10 inch <span className="catering-price">$89</span>                                                                       </li>*/}
                    {/*    <li>Carrot cake 7 inch <span className="catering-price">$39</span> 10 inch <span className="catering-price">$69</span>                                                                 </li>*/}
                    {/*    <li>Donut tower 10 pcs <span className="catering-price">$59</span>, 20 pcs <span className="catering-price">$110 </span>                                                               </li>*/}
                    {/*</ul>*/}
                </Col>

            </Row>


            <TextTitle text={
                <Fragment>
                    Cakes
                </Fragment>
            } />

            <Row>
                <Col lg={{ size: 8, offset: 2 }} className="text-center">

                    <p className="catering-header">
                        Sponge
                    </p>
                    <p className="catering-body">
                        7 inch <span className="catering-price">$39</span>, 10 inch <span className="catering-price">$69</span>
                    </p>
                    <p className="catering-header">
                        Mud cake, Red velvet
                    </p>
                    <p className="catering-body">
                        7 inch <span className="catering-price">$49</span>, 10 inch <span className="catering-price">$79</span>
                    </p>
                    <p className="catering-header">
                        Cheesecake
                    </p>
                    <p className="catering-body">
                        10 inch <span className="catering-price">$79</span> (Biscoff, Nutella, Pistachio, Berry compote) 
                    </p>
                    <p className="catering-header">
                        Cannoli tower
                    </p>
                    <p className="catering-body">
                        10 cannoli <span className="catering-price">$60</span>, 20 cannoli <span className="catering-price">$110</span> (Ricotta, Pistachio, Chocolate, raspberry, Custard) 
                    </p>

                    <p className="catering-header">
                        Hummingbird cake
                    </p>
                    <p className="catering-body">
                        7 inch <span className="catering-price">$49</span>, 10 inch <span className="catering-price">$79</span>
                    </p>

                    <p className="catering-header">
                        Carrot cake
                    </p>
                    <p className="catering-body">
                        7 inch <span className="catering-price">$49</span>, 10 inch <span className="catering-price">$79</span>
                    </p>

                    <p className="catering-header">
                        Donut tower
                    </p>
                    <p className="catering-body">
                        10 pcs <span className="catering-price">$59</span>, 20 pcs <span className="catering-price">$110</span>
                    </p>

                    {/*<p className="catering-body">*/}
                    {/*    <ul>*/}
                    {/*        <li>Sponge 7 inch <span className="catering-price">$39</span>, 10 inch <span className="catering-price">$59</span>                                                                     </li>*/}
                    {/*        <li>Mud cake, Red velvet 7 inch <span className="catering-price">$49</span>, 10 inch, <span className="catering-price">$69</span>                                                      </li>*/}
                    {/*        <li>Cheesecake 10 inch <span className="catering-price">$79</span> (Biscoff, Nutella, Pistachio, Berry compote)                                </li>*/}
                    {/*        <li>Cannoli tower 10 cannoli <span className="catering-price">$60</span>, 20 cannoli <span className="catering-price">$110</span> (Ricotta, Pistachio, Chocolate, raspberry, Custard)  </li>*/}
                    {/*        <li>Hummingbird cake 10 inch <span className="catering-price">$89</span>                                                                       </li>*/}
                    {/*        <li>Carrot cake 7 inch <span className="catering-price">$39</span> 10 inch <span className="catering-price">$69</span>                                                                 </li>*/}
                    {/*        <li>Donut tower 10 pcs <span className="catering-price">$59</span>, 20 pcs <span className="catering-price">$110 </span>                                                               </li>*/}
                    {/*    </ul>*/}
                    {/*</p>*/}  

                </Col>
            </Row>


            <TextTitle text={
                <Fragment>
                    Our Pies
                </Fragment>
            } />

            <Row>
                <Col lg={{ size: 5, offset: 2 }}>
                    <ul>
                        <li>chunky angus <span className="catering-price">$8.00</span>  </li>
                        <li>plain mince <span className="catering-price">$6.50</span>  </li>
                        <li>steak and onion <span className="catering-price">$6.90</span>  </li>
                        <li>steak, bacon and cheese <span className="catering-price">$6.70</span>  </li>
                        <li>steak and curry <span className="catering-price">$7.50</span>  </li>
                        <li>steak and mushroom <span className="catering-price">$6.50</span>  </li>
                        <li>chiken and vegetables <span className="catering-price">$7.50</span>  </li>
                        <li>potato <span className="catering-price">$7.50</span>  </li>
                        <li>curry chicken <span className="catering-price">$7.50</span>  </li>
                    </ul>
                </Col>

                <Col lg="5">
                    <ul>
                        <li>peper steak <span className="catering-price">$7.50</span>  </li>
                        <li>sausage roll<span className="catering-price">$5.20</span>  </li>
                        <li>spinach and feta <span className="catering-price">$6.50</span>  </li>
                        <li>satay<span className="catering-price">$8.50</span>  </li>
                        <li>lasagna <span className="catering-price">$8.50</span>  </li>
                        <li>butter chicken <span className="catering-price">$8.50</span>  </li>
                        <li>stroganoff <span className="catering-price">$8.50</span>  </li>
                        <li>vegan pie <span className="catering-price">$9.50</span>  </li>
                    </ul>

                </Col>

            </Row>


        </Block>
    );
}
export default Catering;
